import React from 'react';
import './ExamControls.css';

const ExamControls = ({ 
  currentQuestion, 
  totalQuestions, 
  onPrevious, 
  onNext, 
  onSubmit,
  canGoBack,
  canGoNext,
  showSubmit,
  isPaused,
  onPause,
  onResume
}) => {
  return (
    <div className="exam-controls">
      <div className="navigation-controls">
        <button 
          className="btn btn-secondary"
          onClick={onPrevious}
          disabled={!canGoBack}
        >
          ← Previous
        </button>
        
        <div className="question-indicator">
          {currentQuestion + 1} of {totalQuestions}
        </div>
        
        {canGoNext ? (
          <button 
            className="btn btn-primary"
            onClick={onNext}
          >
            Next →
          </button>
        ) : showSubmit ? (
          <button 
            className="btn btn-success submit-btn"
            onClick={onSubmit}
          >
            Submit Exam
          </button>
        ) : (
          <button 
            className="btn btn-primary"
            disabled
          >
            Next →
          </button>
        )}
      </div>
      
      <div className="exam-actions">
        {isPaused ? (
          <button 
            className="btn btn-warning"
            onClick={onResume}
          >
            Resume Exam
          </button>
        ) : (
          <button 
            className="btn btn-warning"
            onClick={onPause}
          >
            Pause Exam
          </button>
        )}
        
        <button 
          className="btn btn-danger"
          onClick={onSubmit}
        >
          End Exam
        </button>
      </div>
    </div>
  );
};

export default ExamControls;